const EMAIL_PRODUCT_TIER = {
  FREE: 'FREE',
  STARTER: 'STARTER',
  STANDARD: 'STANDARD'
};
export default EMAIL_PRODUCT_TIER;